import { ACTION_RESET_APP_STATE, OP } from "../../constant";

// ---- authentications
export function logoutRequest() {
    return {
        type: OP.LOGIN_RESET
    }
}

export function loginRequest(username, password, fcm_token) {
    return {
        type: OP.LOGIN_REQUEST,
        payload: {
            username,
            password,
        }
    }
}

export function loginReset() {
    return {
        type: OP.LOGIN_RESET
    }
}

// ---- otp
export function otpRequest(username, OTP) {
    return {
        type: OP.OTP_REQUEST,
        payload: {
            username,
            OTP
        }
    }
}

export function otpReset() {
    return {
        type: OP.OTP_RESET
    }
}


// ---- reset password
export function forgetPasswordRequest(data) {
    return {
        type: OP.FORGET_PASSWORD_REQUEST,
        payload: {
            data
        }
    }
}

export function resetForgetPassword() {
    return {
        type: OP.FORGET_PASSWORD_RESET
    }
}

// ---- change password
export function changePasswordRequest(token, data) {
    return {
        type: OP.CHANGE_PASSWORD_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function changePasswordReset() {
    return {
        type: OP.CHANGE_PASSWORD_RESET
    }
}


// ---- dashboard
export function fetchDashboardRequest(token) {
    return {
        type: OP.DASHBOARD_REQUEST,
        payload: {
            token
        }
    }
}

export function fetchDashboardReset() {
    return {
        type: OP.DASHBOARD_RESET
    }
}

// ---- transactions
export function transactionsRequest(token, data) {
    return {
        type: OP.TRANSACTIONS_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function transactionsReset() {
    return {
        type: OP.TRANSACTIONS_RESET
    }
}

// ---- notifications
export function notificationsRequest(token, data) {
    return {
        type: OP.NOTIFICATIONS_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function notificationsReset() {
    return {
        type: OP.NOTIFICATIONS_RESET
    }
}

// ---- logs
export function logsRequest(token, data) {
    return {
        type: OP.LOGS_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function logsReset() {
    return {
        type: OP.LOGS_RESET
    }
}

// ---- reset app state
export function resetAppState() {
    return {
        type: ACTION_RESET_APP_STATE
    }
}